define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var RecurringProfileModel = /** @class */ (function () {
        function RecurringProfileModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.ExternalId = ko.observable();
            this.LocationId = ko.observable(0);
            this.Tax1Name = ko.observable();
            this.Tax2Name = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, RecurringProfileModel.Mapping, self);
            }
        }
        RecurringProfileModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new RecurringProfileModel(options.data);
            }
        };
        return RecurringProfileModel;
    }());
    return RecurringProfileModel;
});
//# sourceMappingURL=RecurringProfileModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/RecurringProfileModel.js
// module id = 199
// module chunks = 2